<template>
  <div class="form-group">
    <label v-if="label" :for="name">{{ label }}</label>
    <div :class="{ 'input-group': $slots.default, field_with_errors: error }">
      <input
        :id="name"
        :disabled="disabled"
        :value="value"
        :required="required"
        :type="type"
        :placeholder="placeholder"
        :name="name"
        :min="min"
        :step="step"
        :size="maxlength"
        :maxlength="maxlength"
        @input="changeValue"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        @keydown="keydownHandler"
        class="form-control"
      />
      <div v-if="$slots.default" class="input-group-append">
        <slot></slot>
      </div>
    </div>
    <div v-if="error" class="formError">{{ error }}</div>
  </div>
</template>

<script>
import inputError from "../mixins/inputError";

export default {
  name: "FormInput",
  mixins: [inputError],
  props: {
    value: {
      type: [String, Number],
      default: "",
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxlength: {
      type: Number,
      default: undefined,
    },
    min: { type: Number, default: null },
    step: { type: Number, default: undefined },
  },
  methods: {
    changeValue(e) {
      let value = e.target.value;
      if (this.type === "integer") {
        value = parseInt(value.match(/^(\d*)/g));
        if (!(value || value === 0)) value = null;
      }
      e.target.value = value;
      this.$emit("input", value);
    },
    keydownHandler(event) {
      if (this.type === "integer") {
        if (event.ctrlKey) return;
        if (event.key.match(/\d/) || event.key.length > 1) return;

        event.preventDefault();
      }
    },
  },
};
</script>
